import * as actions from './actionsTypes';

const initialData = {
  loaderDashboardContrataciones: false,
  dashboardSelectDataContrataciones: {},
  dashboardErrorContrataciones: ''
}

export default function DashBoardSelectContratacionesReducer(state = initialData, action){
    
  switch (action.type) {
    case actions.LOADING_DASHBOARD_SELECT_RESPONSIBLE_CONTRATACIONES:
      return {...state, loaderDashboardContrataciones: action.payload}
    case actions.GET_DASHBOARD_SELECT_RESPONSIBLE_CONTRATACIONES:
      return {...state, dashboardSelectDataContrataciones: action.payload}
    case actions.DASHBOARD_SELECT_ERROR_CONTRATACIONES:
      return {...state, dashboardErrorContrataciones: action.payload}
    default:
      return state
  }
}